import React from 'react';
import Button from '../common/Button';

const FinalCTA = () => {
  return (
    <div className="py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Ready to get started?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Join thousands of businesses already growing with CustMax.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-6 mb-12">
          <Button variant="primary" size="lg">
            Explore Help Center
          </Button>
          <Button variant="outline" size="lg">
            Talk to Support
          </Button>
        </div>
        
        <div className="bg-gray-100 rounded-xl p-8 flex flex-col md:flex-row items-center justify-between">
          <div className="mb-6 md:mb-0 text-center md:text-left">
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              Still have questions?
            </h3>
            <p className="text-gray-600">
              Schedule a personalized demo with our product specialists.
            </p>
          </div>
          <Button variant="secondary" size="md">
            Book a Demo
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FinalCTA;